import request from "@/service";

/* 查询专题列表 */
export function getSubjectInfoList(params) {
  return request({
    url: `/resource/subject/info/page`,
    method: "post",
    data: params
  });
}

/* 专题新增 */
export function saveSubjectInfo(params) {
  return request({
    url: `/resource/subject/info/save`,
    method: "post",
    data: params
  });
}

/* 专题详情 */
export function getSubjectInfo(params) {
  return request({
    url: `/resource/subject/info/info/${params.uuid}`,
    method: "get"
  });
}

/* 专题修改 */
export function updateSubjectInfo(params) {
  return request({
    url: `/resource/subject/info/update`,
    method: "put",
    data: params
  });
}

/* 专题删除 */
export function deleteSubjectInfo(params) {
  return request({
    url: `/resource/subject/info/delete`,
    method: "delete",
    data: params
  });
}

/* 上线/下线 */
export function onlineSubjectInfo(params) {
  return request({
    url: `resource/subject/info/onlineStatus`,
    method: "put",
    data: params
  });
}

/* 推荐/不推荐 */
export function recomandSubjectInfo(params) {
  return request({
    url: `resource/subject/info/recommended`,
    method: "put",
    data: params
  });
}

// 专题共享记录
export function subjectSharePage(data) {
  return request({
    url: `/resource/subject/info/sharePage`,
    method: "get",
    params: data
  });
}

// 恢复专题共享
export function recoverySubect(data) {
  return request({
    url: `/resource/subject/info/recoverySubect`,
    method: "put",
    data
  });
}

// 专题共享
export function shareSubject(data) {
  return request({
    url: `/resource/subject/info/shareSubject`,
    method: "put",
    data
  });
}

// 取消专题共享
export function cancelShareSubject(data) {
  return request({
    url: `/resource/subject/info/cancelShareSubject`,
    method: "put",
    data
  });
}

// 同步专题
export function syncSubject(data) {
  return request({
    url: `/resource/subject/info/syncSubject`,
    method: "put",
    data
  });
}

//拖拽排序
export function subjectInfoDrag(data) {
  return request({
    url: `/resource/subject/info/updateOrderByDrag`,
    method: "put",
    data
  });
}

//复制专题
export function copySubject(data) {
  return request({
    url: `/resource/subject/info/copy`,
    method: "post",
    data
  });
}

// 获取专题列表
export function getSubjectByName(params) {
  return request({
    url: `/resource/subject/info/namePage`,
    method: "get",
    params
  });
}

// 获取专题资源统计 
export function subjectBasic(params) {
  return request({
    url: `/resource/subject/info/statistic/basic`,
    method: "get",
    params,
  });
}
// 获取专题统计明细
export function subjectLearn(data) {
  return request({
    url: `/resource/subject/info/statistic/learn`,
    method: "post",
    data,
  });
}

export function exportSubjectStatisticInfo(data) {
  return request({
    url: `/resource/subject/info/statistic/exportLearn`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

export function exportSubResourceStatisticInfo(data) {
  return request({
    url: `/resource/subject/info/statistic/exportResourceLearn`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

// 获取专题板块列表
export function subjectBlockList(params) {
  return request({
    url: `/resource/subject/block/list`,
    method: "get",
    params,
  });
}

// 专题资源学习详情分页
export function subjectResourceInfo(params) {
  return request({
    url: `/resource/subject/info/statistic/resourceInfo`,
    method: "get",
    params,
  });
}


// 修改专题展示终端
export function updateSubjectDisplay(data) {
  return request({
    url: `/resource/subject/info/updateSubjectDisplay`,
    method: "post",
    data,
  });
}